module.exports = __webpack_public_path__ + "img/product-details.b928ad24.jpg";